import { Injectable } from '@angular/core';
import {GiiRegistracijaApi} from "../api/gii-registracija.api";
import {BehaviorSubject, catchError, Observable, throwError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {SharedDataService} from "./shared-data.service";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class RegPerziuraService {
  private fetchGiiRegByIdUrl = environment.apiBaseUrl + '/internalApi/fetchGiiRegById';
  private perziuraSubject = new BehaviorSubject<{ selectedId: number | null; srautoKodas: string } | null>(null);
  perziura$ = this.perziuraSubject.asObservable();

  constructor(private http: HttpClient,
              private sharedDataService: SharedDataService) {}

  fetchGiiRegistracijaById(giiRegId: number): Observable<GiiRegistracijaApi> {
    const requestBody = { giiRegId };
    return this.http.post<GiiRegistracijaApi>(this.fetchGiiRegByIdUrl, requestBody, { withCredentials: true }).pipe(
      catchError((error) => {
        this.sharedDataService.setKlaidos(error.error);
        this.sharedDataService.setIsLoading(false);
        this.closePerziura();
        return throwError(error);
      })
    );
  }

  openRegPerziura(selectedId: number | null, srautoKodas: any): void {
    if (selectedId !== null) {
      this.perziuraSubject.next({selectedId, srautoKodas});
    }
  }

  closePerziura() {
    this.perziuraSubject.next(null);
  }
}
